
import { Vue } from "vue-class-component";

export default class AdminTemplate extends Vue { }
